module.exports = __webpack_public_path__ + "static/media/screenshot(20).633371d0.jpg";